import React, { useEffect, useState } from "react";
import classNames from "classnames";
// entities
import { Table, TableItem } from "entities/users";
// widgets
import { rowNames } from "widgets/users/users-items/lib";
import Pagination from "widgets/page-pagination";
// lib
import { IUAccountListWidget } from "../types";
import { finalyValues } from "../lib/helpers";
// shared
import { SortButton } from "shared/ui/sort-button";

const AccountListWidget: React.FC<IUAccountListWidget> = ({
  haveChat,
  users,
  page,
  type,
  searchText,
}) => {
  // sorted and filtered
  const [sort, setSort] = useState(true);
  const filteredUsers = users ? finalyValues(users, sort) : [];
  const searchedUsers = searchText
    ? filteredUsers.filter(
        (user) =>
          (user.first_name &&
            user.first_name.toLowerCase().includes(searchText.toLowerCase())) ||
          (user.second_name &&
            user.second_name
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (user.last_name &&
            user.last_name.toLowerCase().includes(searchText.toLowerCase())),
      )
    : filteredUsers;

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(searchedUsers.length / 7);
  const startIndex = (currentPage - 1) * 7;
  const endIndex = startIndex + 7;
  const usersOnCurrentPage = searchedUsers.slice(startIndex, endIndex);

  const goToPage = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className={"w-full h-[80%] rounded-xl overflow-auto flex flex-col"}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        goToPage={goToPage}
      />
      <Table
        cells={rowNames.map((cell) => (
          <div
            key={cell.id}
            className={classNames("flex")}
            style={{ width: cell.width }}
          >
            <span className={"text-[#111111] opacity-30"}>{cell.title}</span>
            {cell.title === "Статус" ? (
              <SortButton sort={sort} setSort={setSort} />
            ) : null}
          </div>
        ))}
        rows={usersOnCurrentPage.map((row, index: number) => (
          <TableItem
            index={startIndex + index + 1}
            key={row.id}
            image={row.avatar}
            firstName={type === "school" ? row.phone : row.first_name}
            secondName={row.second_name}
            lastName={row.last_name}
            status={row.state}
            haveChat={haveChat}
            id={row.id}
            page={page}
          />
        ))}
      />
      <div className="mt-auto">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          goToPage={goToPage}
        />
      </div>
    </div>
  );
};

export { AccountListWidget };
